export default "__VITE_ASSET__9uwY8ymy__"